// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__S_PJd"};